import type { Template } from "@/types";

export const SQ_05_H3_V2: Template[] = [
    {
        id: "sq-05-h3v2-01",
        name: "SQ 01 - H3V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h3_v2_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 72, y: 144, width: 283, height: 430, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 144, width: 282, height: 430, rotation: 0, imageRotation: 0 },
            { id: "3", x: 859, y: 433, width: 213, height: 141, rotation: 0, imageRotation: 0 },
            { id: "4", x: 859, y: 144, width: 433, height: 282, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 433, width: 212, height: 141, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h3v2-02",
        name: "SQ 02 - H3V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h3_v2_02.png",
        size: [1434, 717],
        style: {},
        slots: [       
            { id: "1", x: 72, y: 144, width: 283, height: 430, rotation: 0, imageRotation: 0 },
            { id: "2", x: 362, y: 144, width: 283, height: 430, rotation: 0, imageRotation: 0 },
            { id: "3", x: 822, y: 108, width: 507, height: 329, rotation: 0, imageRotation: 0 },
            { id: "4", x: 822, y: 444, width: 250, height: 166, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 444, width: 249, height: 166, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h3v2-03",
        name: "SQ 03 - H3V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h3_v2_03.png",
        size: [1434, 717],
        style: {},
        slots: [    
            { id: "1", x: 0, y: 158, width: 258, height: 400, rotation: 0, imageRotation: 0 },
            { id: "2", x: 266, y: 158, width: 257, height: 400, rotation: 0, imageRotation: 0 },
            { id: "3", x: 531, y: 158, width: 292, height: 196, rotation: 0, imageRotation: 0 },
            { id: "4", x: 531, y: 362, width: 292, height: 196, rotation: 0, imageRotation: 0 },
            { id: "5", x: 831, y: 158, width: 603, height: 400, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h3v2-04",
        name: "SQ 04 - H3V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h3_v2_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 158, width: 604, height: 400, rotation: 0, imageRotation: 0 },
            { id: "2", x: 611, y: 158, width: 258, height: 400, rotation: 0, imageRotation: 0 },
            { id: "3", x: 876, y: 158, width: 258, height: 400, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1141, y: 158, width: 293, height: 196, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1141, y: 361, width: 293, height: 197, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h3v2-05",
        name: "SQ 05 - H3V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h3_v2_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 44, y: 97, width: 384, height: 258, rotation: 0, imageRotation: 0 },
            { id: "2", x: 435, y: 97, width: 169, height: 258, rotation: 0, imageRotation: 0 },
            { id: "3", x: 44, y: 362, width: 169, height: 258, rotation: 0, imageRotation: 0 },
            { id: "4", x: 220, y: 362, width: 384, height: 258, rotation: 0, imageRotation: 0 },
            { id: "5", x: 611, y: 97, width: 780, height: 523, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h3v2-06",
        name: "SQ 06 - H3V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h3_v2_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 72, y: 74, width: 281, height: 185, rotation: 0, imageRotation: 0 },
            { id: "2", x: 72, y: 267, width: 281, height: 184, rotation: 0, imageRotation: 0 },
            { id: "3", x: 72, y: 459, width: 281, height: 184, rotation: 0, imageRotation: 0 },
            { id: "4", x: 360, y: 74, width: 285, height: 569, rotation: 0, imageRotation: 0 },
            { id: "5", x: 882, y: 74, width: 386, height: 569, rotation: 0, imageRotation: 0 }  
        ],
    },

    {
        id: "sq-05-h3v2-07",
        name: "SQ 07 - H3V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h3_v2_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 166, y: 74, width: 386, height: 569, rotation: 0, imageRotation: 0 },      
            { id: "2", x: 789, y: 74, width: 281, height: 185, rotation: 0, imageRotation: 0 },
            { id: "3", x: 789, y: 267, width: 281, height: 184, rotation: 0, imageRotation: 0 },
            { id: "4", x: 789, y: 459, width: 281, height: 184, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1077, y: 74, width: 285, height: 569, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h3v2-08",
        name: "SQ 08 - H3V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h3_v2_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 108, y: 195, width: 489, height: 327, rotation: 0, imageRotation: 0 },
            { id: "2", x: 604, y: 195, width: 248, height: 160, rotation: 0, imageRotation: 0 },
            { id: "3", x: 604, y: 362, width: 248, height: 160, rotation: 0, imageRotation: 0 },
            { id: "4", x: 859, y: 195, width: 230, height: 327, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1096, y: 195, width: 230, height: 327, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h3v2-09",
        name: "SQ 09 - H3V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h3_v2_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 61, y: 181, width: 527, height: 355, rotation: 0, imageRotation: 0 },
            { id: "2", x: 595, y: 181, width: 248, height: 355, rotation: 0, imageRotation: 0 },
            { id: "3", x: 850, y: 181, width: 248, height: 355, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1105, y: 181, width: 268, height: 174, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1105, y: 362, width: 268, height: 174, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h3v2-10",
        name: "SQ 10 - H3V2",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h3_v2_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 74, y: 64, width: 492, height: 589, rotation: 0, imageRotation: 0 },     
            { id: "2", x: 573, y: 64, width: 287, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 573, y: 263, width: 287, height: 191, rotation: 0, imageRotation: 0 },
            { id: "4", x: 573, y: 462, width: 287, height: 191, rotation: 0, imageRotation: 0 },
            { id: "5", x: 867, y: 64, width: 492, height: 589, rotation: 0, imageRotation: 0 }
        ],
    },
    

];

